// Pure helpers for SuggestionPanel.jsx's "combine, don't replace" template
// application — extracted so this logic is unit-testable with node:test
// without any React/JSX machinery.

import { companySignatureInfo } from './constants/companies.js'

// This app's three current signature forms, always the message's final line:
//   1. "[AGENT_FIRST_NAME] | <signature>"  — unresolved placeholder (draft.js/prompts.js house style)
//   2. "<Name> | <signature>"              — resolved (resolveAgentFirstNamePlaceholder,
//                                            or a legacy $(user.firstName)-substituted DB template)
//   3. "<signature>"                       — bare fallback (AM's signature always renders this way;
//                                            for other companies, no name available — either
//                                            resolveAgentFirstNamePlaceholder's own fallback,
//                                            or pipeline.js's buildAddressConfirmationDraft, which
//                                            ends "Thank you,\n<signature>")
// Anchored to the START of a line so the signature mentioned mid-sentence
// elsewhere in a draft is never mistaken for the actual signature line.
// Company-aware (companySignatureInfo(), mirrors companies.js's registry) —
// a hardcoded '1A Auto' literal here would never match AM's own
// 'AM-Autoparts' signature, leaving it unstripped and duplicated once a new
// template's own (freshly re-appended) signature is added below it.
function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function signatureLineRe(account) {
  const sig = escapeRegExp(companySignatureInfo(account).signature)
  return new RegExp(`(?:^|\\n)[ \\t]*(?:[^\\n]*\\|\\s*${sig}|${sig})\\.?[ \\t]*$`, 'i')
}

export function stripTrailingSignature(text, account) {
  return String(text ?? '').replace(signatureLineRe(account), '').replace(/\s+$/, '')
}

// Combines an existing draft (any prior AI-generated or templated content,
// its own trailing signature stripped and discarded) with a new template's
// already-substituted content (its own trailing signature also stripped) —
// the new content goes at the bottom. If the existing draft is empty/blank,
// this is just the new content, same as applying the very first template.
// The caller re-appends exactly ONE signature after this, regardless of how
// many templates have been combined. account: passed through to
// stripTrailingSignature() for both sides — see its own comment.
export function mergeTemplateContent(existingDraft, newTemplateContent, account) {
  const existingBody = stripTrailingSignature(String(existingDraft ?? '').trim(), account)
  const newBody = stripTrailingSignature(newTemplateContent, account)
  return existingBody ? `${existingBody}\n\n${newBody}` : newBody
}
